<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div>
              <img v-if="isSuccess != 3" :src="getImage('logo.svg')" alt="Dotlines" />
              <div class="reset-password" v-if="isSuccess == 1">
                <div class="d-flex align-items-center alert alert-success" role="alert">
                  Your password has been changed successfully!
                  <i class="ml-auto icon-check"></i>
                </div>
                <h3>Next steps</h3>
                <ul>
                  <li>
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.00489 0C4.31254 3.75682 3.75631 4.31254 0 5.00499C3.75631 5.69825 4.31254 6.25397 5.00489 10C5.69774 6.25397 6.25391 5.69825 10.0002 5.00499C6.25391 4.31254 5.69774 3.75682 5.00489 0Z"
                        fill="#00A99C"
                      />
                    </svg>
                    Download the Audra Security app on your device
                  </li>
                  <li>
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.00489 0C4.31254 3.75682 3.75631 4.31254 0 5.00499C3.75631 5.69825 4.31254 6.25397 5.00489 10C5.69774 6.25397 6.25391 5.69825 10.0002 5.00499C6.25391 4.31254 5.69774 3.75682 5.00489 0Z"
                        fill="#00A99C"
                      />
                    </svg>
                    Once you receive your device, follow the instructions on the app to
                    complete the setup in no time.
                  </li>
                </ul>
                <div class="text-center mt-4 mb-3">
                  <h4 class="mb-4">
                    Need help? Browse our
                    <a href="https://help.audrasecurity.com">FAQ’s</a>
                  </h4>
                  <a href="https://audrasecurity.com/">Explore More</a>
                </div>
              </div>
              <div class="reset-password" v-if="isSuccess == 0">
                <div class="alert alert-danger d-flex align-items-center" role="alert">
                  Your password setup link has expired!
                  <i
                    type="button"
                    class="icon-close ml-auto"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                  </i>
                </div>
                <p>
                  Your password setup link is no longer active, please contact your
                  service provider.
                </p>
              </div>
              <form
                v-if="isSuccess == 2"
                @submit.prevent="reset_pass()"
                method="POST"
                class="response-alert"
                novalidate
              >
                <div class="form-group mb-3">
                  <label class="control-label">
                    New Password <sup class="text-danger">*</sup>
                  </label>
                  <div class="password">
                    <input
                      name="password"
                      v-model.trim="resetPassInfo.password"
                      class="form-control"
                      placeholder="Enter Password"
                      @input="validatePassword"
                      :type="showPassword ? 'text' : 'password'"
                      @copy.prevent
                      @cut.prevent
                      @paste.prevent
                      aria-required="true"
                      aria-invalid="false"
                      ref="password"
                    />
                    <span class="password-toggle" @click="togglePassword">
                      <i
                        :class="{
                          'icon-eye-off': showPassword,
                          'icon-eye': !showPassword,
                        }"
                      ></i>
                    </span>
                  </div>
                  <div class="help text-danger" v-if="passwordError">
                    <!-- {{ passwordError }} -->
                  </div>
                  <div class="password-validation">
                    <ul>
                      <li>
                        <i
                          :class="{
                            'icon-check text-success': passwordValidations.lengthValid,
                            'icon-close text-danger': !passwordValidations.lengthValid,
                          }"
                        ></i>
                        Minimum 12 characters
                      </li>
                      <li>
                        <i
                          :class="{
                            'icon-check text-success': passwordValidations.uppercaseValid,
                            'icon-close text-danger': !passwordValidations.uppercaseValid,
                          }"
                        ></i>
                        At least one uppercase letter
                      </li>
                      <li>
                        <i
                          :class="{
                            'icon-check text-success': passwordValidations.numberValid,
                            'icon-close text-danger': !passwordValidations.numberValid,
                          }"
                        ></i>
                        At least one number (0-9)
                      </li>
                      <li>
                        <i
                          :class="{
                            'icon-check text-success':
                              passwordValidations.specialCharValid,
                            'icon-close text-danger': !passwordValidations.specialCharValid,
                          }"
                        ></i>

                        At least one special character (e.g., ! @ # & *)
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <label class="control-label"
                    >Confirm Password <sup class="text-danger">*</sup></label
                  >
                  <div class="password">
                    <input
                      name="password_confirmation"
                      v-model.trim="resetPassInfo.password_confirmation"
                      class="form-control"
                      placeholder="Enter Confirm Password."
                      v-validate="'required|confirmed:password|max:20'"
                      data-vv-as="password"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :class="{
                        'has-error':
                          errors.has('password_confirmation') ||
                          serverErrors.password_confirmation,
                      }"
                      aria-required="true"
                      aria-invalid="false"
                    />
                    <span class="password-toggle" @click="toggleConfirmPassword">
                      <i
                        :class="{
                          'icon-eye-off': showConfirmPassword,
                          'icon-eye': !showConfirmPassword,
                        }"
                      ></i>
                    </span>
                  </div>
                  <div
                    class="help text-danger"
                    v-show="errors.has('password_confirmation')"
                  >
                    {{ errors.first("password_confirmation") }}
                  </div>
                </div>

                <button type="submit" class="btn btn-common btn-block mb-4">
                  Reset Password
                </button>

                <div class="text-center">
                  <router-link
                    class="pc fw-500 align-items-center d-inline-flex"
                    :to="{ name: 'Login' }"
                  >
                    Back to login
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Satisfyingly</span> simple <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import axios from "axios";
// import store from "@/store";

export default {
  components: {
    //
  },
  data: () => ({
    showPassword: false,
    showConfirmPassword: false,
    isSuccess: 3,
    resetPassInfo: {
      send_via: "email",
      mobile_or_email: "",
    },
    pwd_reset_link_validation_url: "",
    is_loading: false,
    serverErrors: {},
    passwordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*(),.?":{}|<>~\\-_+=\[\];'/]).{12,}$/,
    passwordError: "",
    passwordValidations: {
      lengthValid: false,
      uppercaseValid: false,
      numberValid: false,
      specialCharValid: false,
    },
  }),
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    reset_pass: function (e) {
      const _this = this;

      // Check if all password validations are true
      if (
        _this.passwordValidations.lengthValid &&
        _this.passwordValidations.uppercaseValid &&
        _this.passwordValidations.numberValid &&
        _this.passwordValidations.specialCharValid
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            const api_url = this.API_BASE_URL + "/auth/reset-password-v2";
            this.is_loading = true;
            axios({
              method: "post",
              url: api_url,
              data: this.resetPassInfo,
            })
              .then(function (response) {
                if (response.status === 200) {
                  _this.resetPassInfo.password = "";
                  _this.resetPassInfo.password_confirmation = "";
                  _this.isSuccess = 1;
                } else {
                  _this.isSuccess = 0;
                }
              })
              .catch(function (error) {
                if (error.response) {
                  const msg = error.response.data.message;
                  const errors = error.response.data.errors;
                  let errorMessage = "";
                  for (const field in errors) {
                    if (errors.hasOwnProperty(field)) {
                      errors[field].forEach((msg) => {
                        errorMessage += msg + "\n";
                      });
                    }
                  }

                  if (msg) {
                    errorMessage += msg + "\n";
                  }

                  errorMessage = errorMessage.replace(/<br\s*\/?>/gi, "\n");

                  _this.$toaster.error(errorMessage.trim());
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log("Error", error.message);
                }
              })
              .finally(function () {
                _this.is_loading = false;
                _this.is_disabled = false;
                setTimeout(() => {
                  $(".alert").fadeOut("slow");
                }, 5000);
              });
          }
        });
      } else {
        // Show an error message if password validations fail
        _this.$toaster.error("Password does not meet all requirements.");
      }
    },
    verifyResetLink: function () {
      const _this = this;
      const api_url = this.API_BASE_URL + "/auth/verify-reset-link";
      this.is_loading = true;

      axios({
        method: "post",
        url: api_url,
        data: { token: this.$route.query.token },
      })
        .then(function (response) {
          if (response.data.is_valid !== true) {
            _this.isSuccess = 0;
            // _this.$toaster.error("The reset password link is invalid or expired.");
            // _this.$router.push({ name: "Login" });
          } else {
            _this.isSuccess = 2;
          }
        })
        .catch(function (error) {
          _this.isSuccess = 0;
          // _this.$toaster.error("There was an issue validating the reset link.");
          // _this.$router.push({ name: "Login" });
        })
        .finally(function () {
          _this.is_loading = false;
        });
    },
    validatePassword() {
      const password = this.resetPassInfo.password;
      this.passwordValidations.lengthValid = password.length >= 12;
      this.passwordValidations.uppercaseValid = /[A-Z]/.test(password);
      this.passwordValidations.numberValid = /[0-9]/.test(password);
      // this.passwordValidations.specialCharValid = /[!@#$%^&*()-]/.test(password);

      const specialCharRegex = /[!@#$%^&*\-()_=+\[\]{};:\/?.<>,\\|]/;
      this.passwordValidations.specialCharValid = specialCharRegex.test(password);

      if (!password) {
        this.passwordError = "Password is required.";
      } else if (
        !this.passwordValidations.lengthValid ||
        !this.passwordValidations.uppercaseValid ||
        !this.passwordValidations.numberValid ||
        !this.passwordValidations.specialCharValid
      ) {
        this.passwordError = "Password does not meet the requirements.";
      } else {
        this.passwordError = "";
      }
    },
    decodeBase64(base64) {
      const binary = window.atob(base64);
      const bytes = new Uint8Array([...binary].map((char) => char.charCodeAt(0)));
      return new TextDecoder().decode(bytes);
    },
  },
  mounted: function () {
    this.resetPassInfo.send_via = "email";
    this.resetPassInfo.token = this.$route.query.token;
    this.verifyResetLink();
  },
  watch: {
    isSuccess(newVal, oldVal) {
      console.log("isSuccess changed from", oldVal, "to", newVal);
      // You can add more logic here if needed
    },
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
<style scoped>
.alert-success {
  background-color: #00a99c;
  border-color: #00a99c;
  border-radius: 4px;
}
.alert-danger {
  color: #fff;
  background-color: #e12f40;
  border-radius: 4px;
  border-color: #e12f40;
}
.login-box {
  max-width: 440px;
}
.password-toggle {
  width: 48px;
  color: #8e9bae;
  font-size: 18px;
}
.login-box .form-control {
  border-radius: 8px;
  font-size: 14px;
}
.control-label sup {
  font-size: 16px;
}
.password-validation ul {
  padding: 0;
  margin: 0;
  color: #657182;
  list-style: none;
  font-size: 14px;
}
.password-validation ul li {
  margin: 5px 0;
}
.password-validation ul li i {
  font-size: 16px;
  transform: translateY(2px);
  display: inline-block;
  margin-right: 3px;
}
</style>
